import { OrderingInitialState } from '@reducers/ordering/types';

export const removeCustomer = (state: OrderingInitialState): OrderingInitialState => ({
  ...state,
  customerState: {
    ...state.customerState,
    customer: undefined,
    selectedCustomerAddressId: '',
  },
});
